import type { StyleRule } from '@archipro-design/aria';
import {
    captionClassName,
    DESKTOP_TOP_NAV_HEIGHT_FULL_LOGO,
    DESKTOP_TOP_NAV_HEIGHT_SHORT_LOGO,
    MOBILE_TOP_NAV_HEIGHT_FULL_LOGO,
    MOBILE_TOP_NAV_HEIGHT_SHORT_LOGO,
    pxArrayToRem,
    pxToRem,
    TABLET_TOP_NAV_HEIGHT,
} from '@archipro-design/aria';

export const MOBILE_TOP_NAV_FULL_LOGO_HEIGHT = pxToRem(
    MOBILE_TOP_NAV_HEIGHT_FULL_LOGO,
);
export const MOBILE_TOP_NAV_LARGE_LOGO_HEIGHT = pxToRem(
    MOBILE_TOP_NAV_HEIGHT_SHORT_LOGO,
);
// 78 is search input bar height + search input bar margin top, will get these from aria too
export const MOBILE_TOP_NAV_LARGE_LOGO_WITH_INPUT_HEIGHT = pxToRem(
    MOBILE_TOP_NAV_HEIGHT_SHORT_LOGO + 78,
);
export const DESKTOP_TOP_NAV_FULL_LOGO_HEIGHT = pxToRem(
    DESKTOP_TOP_NAV_HEIGHT_FULL_LOGO,
);
export const DESKTOP_TOP_NAV_LARGE_LOGO_HEIGHT = pxToRem(
    DESKTOP_TOP_NAV_HEIGHT_SHORT_LOGO,
);

export const TABLET_TOP_NAV_FULL_LOGO_HEIGHT = pxToRem(TABLET_TOP_NAV_HEIGHT);

export const AOCSectionContainer: StyleRule<{
    forceBackground?: string;
}> = ({ forceBackground }) => ({
    ...(forceBackground && {
        backgroundColor: forceBackground,
    }),
});

export const AOCSection: StyleRule<{
    onDarkPage: boolean;
}> = ({ theme, onDarkPage }) => ({
    padding: pxArrayToRem([60, 50]),
    maxWidth: pxToRem(1920),

    [`& .${captionClassName}`]: {
        display: 'block',
        maxWidth: pxToRem(700),
        lineHeight: theme.siteVariables['lineHeightSmaller'],
        letterSpacing: theme.siteVariables['letterSpacingSmall'],
        color: onDarkPage
            ? theme.siteVariables['colors'].white['100A']
            : '#0D0E12',
    },
    [theme.screen.clamped]: {
        paddingLeft: `max(0px, calc(${pxToRem(1920 + 50)} - 100vw))`,
        margin: 'auto',
    },
});
